module.exports = __webpack_public_path__ + "img/send-bill-and-receipt-en.443090e.png";